export const SLIDES_TO_SCROLL = 4
export const SLIDES_TO_SHOW = 4
export const SLIDES_TO_SHOW_1024 = 3
export const SLIDES_TO_SHOW_768 = 3
export const SLIDES_TO_SHOW_MIN = 1
export const SLIDES_TO_SCROLL_1024 = 3
export const SLIDES_TO_SCROLL_768 = 3
export const SLIDES_TO_SCROLL_MIN = 1
export const MAX_NO_OF_SLIDES_TO_DISPLAY = 12
export const SPEECH_TITLES_DISPLAY_LIMIT = 4
